import React from 'react';

interface BubbleTailIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const BubbleTailIcon = ({className, style}: BubbleTailIconProps) => (
  <svg
    width={20}
    height={14}
    viewBox="0 0 20 14"
    fill="none"
    className={className}
    style={style}>
    <path
      fill="currentColor"
      d="M15.03 0c.078 4.397.374 7.1 1.496 9.304A13.997 13.997 0 0 0 20 13.668V14h-6C6.268 14 0 7.732 0 0h15.03Z"
    />
  </svg>
);
